import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  Nav,
  NavItem,NavLink,UncontrolledTooltip,
  Container,
  Row,
  Col,
  
} from "reactstrap";

class PagesNavbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapseOpen: false,
      color: "navbar-transparent"
    };
  }
  componentDidMount() {
    window.addEventListener("scroll", this.changeColor);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.changeColor);
  }
  changeColor = () => {
    if (
      document.documentElement.scrollTop > 100 ||
      document.body.scrollTop > 100
    ) {
      this.setState({
        color: "primary"
      });
    } else if (
      document.documentElement.scrollTop < 100 ||
      document.body.scrollTop < 100
    ) {
      this.setState({
        color: "navbar-transparent"
      });
    }
  };
  toggleCollapse = () => {
    document.documentElement.classList.toggle("nav-open");
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  onCollapseExiting = () => {
    this.setState({
      collapseOut: "collapsing-out"
    });
  };
  onCollapseExited = () => {
    this.setState({
      collapseOut: ""
    });
  };
  render() {
    return (
      <Navbar className={"fixed-top " + this.state.color} color-on-scroll="100" expand="lg">
      <Container>
        <div className="navbar-translate">
          <NavbarBrand to="/" id="navbar-brand" tag={Link}>
            <span>•EDICODETOR•</span>
          </NavbarBrand>
          <button
              aria-expanded={this.state.collapseOpen}
              className="navbar-toggler navbar-toggler"
              onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
        </div>
        <Collapse
            className={"justify-content-end " + this.state.collapseOut}
            navbar
            isOpen={this.state.collapseOpen}
            onExiting={this.onCollapseExiting}
            onExited={this.onCollapseExited}
          >
            <div className="navbar-collapse-header">
              <Row>
                <Col className="collapse-brand" xs="6">
                  •EDICODETOR•
                </Col>
                <Col className="collapse-close text-right" xs="6">
                  <button
                    aria-expanded={this.state.collapseOpen}
                    className="navbar-toggler"
                    onClick={this.toggleCollapse}
                  >
                    <i className="tim-icons icon-simple-remove" />
                  </button>
                </Col>
              </Row>
            </div>
            <Nav navbar>
            <NavItem>
                <NavLink to="/editor" tag={Link}>
                  &nbsp;
                  <i className="tim-icons icon-paper" id="editor" aria-hidden="true"></i>
                  Editor

                </NavLink>
                <UncontrolledTooltip delay={0} placement="top" target="editor">
                    Editor
                </UncontrolledTooltip>
            </NavItem>
            <NavItem>
              <NavLink to='/' tag={Link} style={{fontSize:'1rem'}}>
                <i id="home" className="fa fa-home"></i>
              </NavLink>
              <UncontrolledTooltip placement="top" target="home">
                Home
              </UncontrolledTooltip>
            </NavItem>
          </Nav>
          </Collapse>
      </Container>
    </Navbar>
    );
  }
}

export default PagesNavbar;
